module.exports = __webpack_public_path__ + "img/NL333.26b10e64.png";